import { IKeyedObject } from '@dirootie-extensions/typescript';
//import { IRoute } from '@components-common/elements';
//TODO: Move to elements package
interface IRoute {
  template: string;
  data: any;
}

export const buildRestUrls = (
  basePath: string,
  params?: {
    list?: any;
    create?: any;
    details?: any;
    update?: any;
    delete?: any;
  }
) => {
  const elementTemplate = `${basePath}/{id}`;
  return {
    list: basePath,
    create: basePath,
    details: elementTemplate,
    update: elementTemplate,
    delete: elementTemplate,
    ...params,
  };
};

export const buildRoutes = (
  template: string,
  routeData: [string, string, any][]
) => {
  let routeResult: IKeyedObject<any> = {};
  routeData.forEach((x) => {
    routeResult[x[0]] = { template: `${template}/${x[1]}`, ...x[2] };
  });
  return routeResult;
};

type UrlUtils = {
  buildRestUrls: typeof buildRestUrls;
  buildRoutes: (
    template: string,
    routeData: [string, string, any][]
  ) => IKeyedObject<Partial<IRoute>>;
  buildCommonRoutes: (
    template: string,
    routeData: any
  ) => IKeyedObject<Partial<IRoute>>;
};

const internalUrlUtils = (): UrlUtils => {
  return {
    buildRestUrls,
    buildRoutes,
    buildCommonRoutes: (template: string, data: any) =>
      buildRoutes(template, [
        ['index', '', data],
        ['details', ':id', data],
        ['create', 'new', data],
      ]),
  };
};

export const urlUtils = internalUrlUtils();
